export enum OfficeAddressKind {
    None,
    VirtualAddress = "VirtualAddress",
    NewAddress = "NewAddress",
    ExistingAddress = "ExistingAddress"
}
